import styled from '@emotion/styled'

export const GroupWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`
